import type { DefaultRootState } from 'react-redux';

export const selectDM = (state: DefaultRootState) => state.dataManagement;
